module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/flags/eu-27e29b9780e61ac627b9aa9702a81eb9.svg";